import * as React from 'react';
import {ListingProviderType} from '../../models/enums';
import {ListingPreviewImageProps} from './types';
import airbnbBadge from '../../images/airbnb-badge.svg';
import agodaBadge from '../../images/agoda-badge.svg';
import bookingBadge from '../../images/booking-badge.svg';
import travelokaBadge from '../../images/traveloka-badge.png';
import vrboBadge from '../../images/vrbo-badge.svg';
import {styled} from '../../utils';

const Root = styled('div')({position: 'relative', width: 88, height: 64});

const imgDefaultStyle: React.CSSProperties = {
  borderRadius: 3,
  display: 'block',
  width: 88,
  height: 64
};

const badgeDefaultStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: -3,
  right: -3,
  width: 16,
  border: '2px solid white',
  borderRadius: '50%'
};

export default class ListingPreviewImage extends React.Component<ListingPreviewImageProps, {}> {
  public render() {
    const {src, badge, badgeClassName, badgeStyle, ...restProps} = this.props;

    return (
      <Root {...restProps}>
        <img src={src} style={imgDefaultStyle} />
        {this._badgeImage ? <img src={this._badgeImage} style={badgeDefaultStyle} /> : null}
      </Root>
    );
  }

  private get _badgeImage() {
    const {badge} = this.props;

    switch (badge) {
      case ListingProviderType.AIRBNB:
        return airbnbBadge;
      case ListingProviderType.AGODA:
        return agodaBadge;
      case ListingProviderType.BOOKING:
        return bookingBadge;
      case ListingProviderType.TRAVELOKA:
        return travelokaBadge;
      case ListingProviderType.VRBO:
        return vrboBadge;
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ListingPreviewImage/ListingPreviewImage.tsx